const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getMonthForecast = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_MONTHLY_FORECAST_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_MONTHLY_FORECAST_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};

export default getMonthForecast;